import React from 'react';

interface ToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  label?: string;
  description?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
}

const Toggle: React.FC<ToggleProps> = ({ enabled, onChange, label, description, disabled = false, size = 'md' }) => {
  const sizes = {
    sm: { track: 'w-9 h-5', thumb: 'h-4 w-4', translate: 'translate-x-4' },
    md: { track: 'w-11 h-6', thumb: 'h-5 w-5', translate: 'translate-x-5' },
  };
  const s = sizes[size];

  return (
    <div className={`flex items-center justify-between ${label ? 'py-2' : ''}`}>
      {(label || description) && (
        <div className="flex-1 min-w-0 mr-3">
          {label && <p className="text-sm font-medium text-gray-900">{label}</p>}
          {description && <p className="text-xs text-gray-500 mt-0.5">{description}</p>}
        </div>
      )}
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        aria-label={label}
        disabled={disabled}
        onClick={() => !disabled && onChange(!enabled)}
        className={`
          relative inline-flex flex-shrink-0 ${s.track} rounded-full cursor-pointer
          transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2
          ${enabled ? 'bg-purple-600' : 'bg-gray-200'}
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `}
      >
        <span
          className={`
            pointer-events-none inline-block ${s.thumb} rounded-full bg-white shadow-lg ring-0
            transform transition-transform duration-200 ease-in-out
            ${enabled ? s.translate : 'translate-x-0.5'}
            mt-0.5
          `}
        />
      </button>
    </div>
  );
};

export default Toggle;
